import React, { FC } from 'react';
import { CheckedIcon } from '@wwe-portal/ui/components/icons/checked-icon';
import Image from 'next/image';
import { rosterClassColors } from '@wwe-portal/ui/features/roster/roster-attributes/roster-class';
import { tiersMap } from '@wwe-portal/ui/features/roster/roster-attributes/tier';
import { RosterCardLayout } from './roster-card-layout';
import { RosterPlaylist } from '../roster-playlist';
import { rosterPlayStyles } from '../roster-attributes/play-style';

interface RosterCardBackDetailProps {
  stats: {
    playStyle: string;
    classValue: {
      class: string;
      class_ID: string;
    };
    tier: string;
  };
  flipCardComponent?: React.ReactNode;
  videoLinks?: {
    image: string;
    link: string;
  }[];
}

export const RosterCardBackDetail: FC<RosterCardBackDetailProps> = ({
  videoLinks,
  stats,
  flipCardComponent,
}) => {
  const { classValue, tier, playStyle } = stats;

  const classImage = rosterClassColors.find((item) =>
    classValue.class_ID.includes(item.id)
  );
  const tierImage = tier ? tiersMap[tier] : undefined;
  const playStyleImage = rosterPlayStyles.find(
    (item) => item.playStyle === playStyle && item.color === classValue.class_ID
  );

  return (
    <RosterCardLayout
      className="h-full"
      image={
        <div className="flex h-full w-full flex-col items-center justify-between gap-5 italic">
          <RosterPlaylist videoLinks={videoLinks} />
          <div className="mx-auto flex w-full flex-col justify-start gap-2">
            {classImage ? (
              <StatRowLayout
                iconUrl={classImage.iconUrl}
                title={classValue.class}
                name="Class"
              />
            ) : null}

            {tierImage ? (
              <StatRowLayout
                iconUrl={tierImage.iconUrl}
                title={tierImage.title}
                name="Tier"
              />
            ) : null}

            {playStyleImage ? (
              <StatRowLayout
                iconUrl={playStyleImage.iconUrl}
                title={playStyleImage.playStyle}
                name="Style"
              />
            ) : null}
          </div>
        </div>
      }
      flipButton={flipCardComponent}
    />
  );
};

const StatRowLayout = ({
  iconUrl,
  title,
  name,
}: {
  iconUrl: string;
  title: string;
  name: string;
}) => {
  return (
    <div className="flex items-center justify-between gap-2 truncate text-xs">
      <div className="flex items-center gap-2">
        <Image src={iconUrl} alt={title} width={24} height={24} />
        <span className="drop-shadow-text-2 font-semibold capitalize text-white">
          {title}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <span className="font-semibold text-[#7F9CF5]">{name}</span>
        <CheckedIcon className="text-green600 ml-1 inline-block h-2 w-2" />
      </div>
    </div>
  );
};
